<template>
    <b-row no-gutters class="mb-15" v-if="signatures">
        <template v-for="(item, index) in signatures">
            <b-col md="4" class="pr-15" :key='index'>
                <gofix-card class="pd-20" classContent="pd-0">
                    <b-row>
                        <b-col md="6">
                            <gofix-text-field label="User" oneline>{{ item.user && item.user.name ? item.user.name : '-' }}</gofix-text-field>
                        </b-col>
                        <b-col md="6">
                            <gofix-text-field label="Signature" class="photosThumb mt-0" classInner="justify-content-end" oneline>
                                <template v-if="item.attachments">
                                    <viewer-image :images="item.attachments" classViewer='d-flex align-items-center'>
                                        <template slot="gofixViewer:list_image" ref="viewerFinding" slot-scope="{images}">
                                            <ul class="list-thumb signature_v2">
                                                <template v-for="(item_image, key) in images">
                                                    <li :key="key">
                                                        <img v-auth-image="item_image.url.original" :alt="item_image.image_file_name" :key="item_image.url.original" src="img/loading.gif">
                                                    </li>
                                                </template>
                                            </ul>
                                        </template>
                                    </viewer-image>
                                </template>
                            </gofix-text-field>
                        </b-col>
                    </b-row>
                </gofix-card>
            </b-col>
        </template>
    </b-row>
</template>

<script>
    const ViewerImage = () => import('../plugins/ViewerImage.vue')
    export default {
        name: 'detail-signature',
        components: {
            ViewerImage
        },
        props: {
            signatures: {
                type: Array,
                default: () => []
            }
        },
        data() {
            return {}
        },
        created() {},
        methods: {}
    }
</script>
